import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";

export default class FullAccessSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Full Access",
            description              : "The Full Access module automatically grants unrestricted access to all organization folders and projects. It's important to note that downgrading the current access level will not alter existing permissions. If you wish to revoke access to a specific folder, you'll need to do so manually.",
            svgIcon                  : "isvg-full-access",
            typeLabel                : "Access & Permissions",
            settingsUrl              : "settings/full-access",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });
    }

}
